import { useTranslation } from 'react-i18next'

import { FormikField } from '../../../Formik'
import { InputField } from '../../../Input'
import { PhoneSelectFormikField } from '../../../Phone'

function ProfileContactsWidgetListCellEditInput({
  autoFocus,
  getErrorProps,
  name,
  typeConfig,
}) {
  const { t } = useTranslation()

  return typeConfig.isPhone ? (
    <PhoneSelectFormikField
      emitOnCountrySelect
      autoFocus={autoFocus}
      controlProps={{ borderless: false }}
      name={name}
    />
  ) : (
    <FormikField
      Component={InputField}
      autoFocus={autoFocus}
      getErrorProps={getErrorProps}
      name={name}
      placeholder={
        typeConfig.placeholderKey ? t(typeConfig.placeholderKey) : undefined
      }
    />
  )
}

export default ProfileContactsWidgetListCellEditInput
